var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoticeBoardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00002 0C8.24381 0 8.46075 0.157165 8.54023 0.391357L9.1956 2.32256H14.8571C15.4883 2.32256 16 2.84248 16 3.48384V11.6128C16 12.2542 15.4883 12.7741 14.8571 12.7741H12.7424L14.2545 17.2299C14.3574 17.5331 14.1989 17.8636 13.9006 17.9681C13.6022 18.0727 13.277 17.9116 13.1741 17.6085L11.5335 12.7741H8.57145V16.2579C8.57145 16.5786 8.31561 16.8386 8.00002 16.8386C7.68443 16.8386 7.42859 16.5786 7.42859 16.2579V12.7741H4.46653L2.82594 17.6085C2.72306 17.9116 2.3978 18.0727 2.09945 17.9681C1.8011 17.8636 1.64264 17.5331 1.74552 17.2299L3.25764 12.7741H1.14286C0.511675 12.7741 0 12.2542 0 11.6128V3.48384C0 2.84248 0.511675 2.32256 1.14286 2.32256H6.80444L7.4598 0.391357C7.53928 0.157165 7.75622 0 8.00002 0ZM1.14286 3.48384V11.6128H14.8571V3.48384H1.14286Z",
    fill: "#5C5E69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoticeBoardIcon);
export default __webpack_public_path__ + "static/media/notice-board-icon.64797a188328a3f5c9622d10f1d9f82e.svg";
export { ForwardRef as ReactComponent };